import { A, useLocation } from '@solidjs/router'

import {
    Component,
    createEffect,
    createMemo,
    onCleanup,
    onMount,
} from 'solid-js'
import { app_state } from 'store/app'

import { IsMobile } from 'comps/helpers'
import {
    HomeFillIcon,
    HomeIcon,
    MapFillIcon,
    MapIcon,
    PersonFillIcon,
    PersonSvg,
} from 'icons/navbar'
import { accountWalletS } from 'pages/account/shared'
import { isMobile } from 'shared'
import { eatery_state, eateryMap } from 'store/eatery'
import { mapState } from 'store/map'
import { search, search_reset } from 'store/search'
import './style/navbar.scss'

export let navContainerRef: HTMLElement | undefined = undefined

const Navbar: Component = () => {
    let circleRef: HTMLElement | null

    const loc = useLocation()

    onMount(() => {
        let ac = new AbortController()

        window.addEventListener(
            'resize',
            () => {
                set_svg()
            },
            {
                signal: ac.signal,
            }
        )

        onCleanup(() => {
            ac.abort()
        })
    })

    createEffect(() => {
        loc.pathname

        let has404 = document.querySelector('#root section.page404')

        if (has404) {
            navContainerRef?.classList.toggle('none', true)
            return
        }

        navContainerRef?.classList.toggle('none', false)

        set_svg()
    })

    function set_svg() {
        let space = 0

        if (!circleRef || isMobile()) return

        let activeNav =
            navContainerRef?.querySelector<HTMLElement>('.nav-tab.active')

        if (!activeNav) return circleActive(false)

        circleActive(true)

        let svg = activeNav.querySelector<HTMLElement>('svg')
        let svgLeft = svg!.getBoundingClientRect().left

        if (innerWidth > 768) {
            let base = activeNav.offsetLeft
            let offset = svgLeft - activeNav.getBoundingClientRect().left

            space = base + offset - svg!.getBoundingClientRect().width / 2

            return (circleRef.style.transform = `translateY(-50%) translateX(${space}px)  translateZ(0)`)
        }

        space = svgLeft - Math.ceil(svg!.getBoundingClientRect().width / 2)

        return (circleRef.style.transform = `translateX(${space}px) translateY(-38%)  translateZ(0)`)
    }

    const circleActive = (bool: boolean) => {
        circleRef?.classList.toggle('inactive', !bool)
    }

    const isHomeActive = () => {
        const p = loc.pathname.replace(/\/+$/, '')
        return p === '' || p === '/rules' || p === '/privacy'
    }

    const hideNav = createMemo(
        () =>
            !!eatery_state.eatery.gene ||
            search.show ||
            mapState.showDiscountInventory ||
            mapState.filters.show ||
            !!accountWalletS.charger.type
    )
    const moveNav = createMemo(
        () => !app_state.is_mobile && search.show && !!eatery_state.eatery.gene
    )

    return (
        <nav
            class='nav-container'
            classList={{
                move: moveNav(),
                hide: hideNav(),

                'fullscreen-hide': eateryMap.imgFullscreen,
                ios: app_state.is_ios,
            }}
            ref={e => {
                navContainerRef = e
                requestAnimationFrame(set_svg)
            }}
        >
            <IsMobile not>
                <div class='circles' ref={e => (circleRef = e)}>
                    <div class='circle'></div>
                    <div class='semi-circle'></div>
                </div>
            </IsMobile>

            <A
                href='/'
                classList={{ active: isHomeActive() }}
                class='nav-tab description'
                activeClass='active'
                inactiveClass=''
                end
            >
                <div class='icon'>
                    <HomeFillIcon classList='home-icon fill' />
                    <HomeIcon />
                </div>
                <div class='holder'>خانه</div>
            </A>
            <A
                href='/map'
                class='nav-tab description'
                activeClass='active'
                inactiveClass=''
                onclick={() => {
                    if (search.show) {
                        search_reset(true)
                    }
                }}
            >
                <div class='icon'>
                    <MapFillIcon classList='map-icon fill' />
                    <MapIcon />
                </div>
                <div class='holder'>نقشه</div>
            </A>
            <A
                href='/account'
                class='nav-tab description'
                activeClass='active'
                inactiveClass=''
            >
                <div class='icon'>
                    <PersonFillIcon classList='account-icon fill' />
                    <PersonSvg />
                </div>
                <div class='holder'>اکانت</div>
            </A>
        </nav>
    )
}

export default Navbar
